import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/DataBeginStartsVehicles/Get`, payload),
    GetById: (payload) => Repository.post(`/api/DataBeginStartsVehicles/GetById`, payload),
    Add: (payload) => Repository.post(`/api/DataBeginStartsVehicles/Add`, payload),
    Copy: (payload) => Repository.post(`/api/DataBeginStartsVehicles/Copy`, payload),
    Edit: (payload) => Repository.post(`/api/DataBeginStartsVehicles/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/DataBeginStartsVehicles/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/DataBeginStartsVehicles/ChangeStatus`, payload),
}